import { getAppEnv } from '../../../../config/env';

const env = getAppEnv();
const { STATIC_PATH_PREFIX } = env.raw;

export const LTS_LANDING_PAGE_URL_PART = '/liveStatus';

export const LTS_ROUTES_PATH = {
  landingPage: `${STATIC_PATH_PREFIX}/liveStatus`,
  trainNumberPage: `${STATIC_PATH_PREFIX}/train-number`,
  datePickerPage: `${STATIC_PATH_PREFIX}/date-picker`,
  stationPickerPage: `${STATIC_PATH_PREFIX}/station-picker`
};

export const POPULAR_TRAIN_KEY = 'popular_trains'; // stores a list of popular trains

export const ASYNC_STORAGE_KEYS = {
  moreDetails: 'LTS_LANDING_MORE_DETAILS_',
  trainRecentSearchHistory: 'train_recent_search:history'
};

export const LABELS = {
  PAGE_HEADER_TITLE: 'Live Train Status',
  TRAIN_PICKER_TITLE: 'TRAIN NAME / NUMBER',
  SELECT: 'Select',
  DATE_PICKER_TRAIN_START_DATE_TITLE: 'Train Start Date',
  DATE_PICKER_TRAIN_BOARDING_DATE_TITLE: 'Boarding Date',
  CHECK_STATUS: 'CHECK STATUS',
  WEEKDAYS: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  TRAIN_RUNS_ON: 'This Train runs on',
  BOARDING_STATION_PICKER_TITLE: 'Select your Boarding Station*',
  BOARDING_STATION_PAGE_HEADER_TITLE: 'Select your Boarding Station',
  TRAIN_SEARCH_INPUT_PLACEHOLDER: 'Enter Train Number/Name',
  CLEAR_BUTTON_LABEL: 'CLEAR',
  RECENT_SEARCHES: 'Recent Searches',
  POPULAR_TRAINS: 'POPULAR TRAINS',
  UPCOMING_JOURNEY: 'UPCOMING JOURNEY',
  CHECK_STATUS_BUTTON_LABEL: 'Check Status now'
};

export const RADIO_OPTIONS = [
  { value: 'train-start-date', label: 'Train Start Date' },
  { value: 'boarding-date', label: 'Boarding Date' }
];

export const RADIO_OPTION_TRAIN_START_DATE = 'train-start-date';

export const POPULAR_TRAINS_ENDPOINT_V1 = 'https://railsinfo-services.makemytrip.com/api/rails/train/popular/v1';

export const STATION_LIST_ENDPOINT_V1 = 'https://railsinfo-services.makemytrip.com/api/rails/train/stations/v1';

export const TRAINS_LIST_ENDPOINT_V1 =
  'https://ground-auto-suggest.makemytrip.com/rails/autosuggest/trains?limit=10&version=v3';

export const UPCOMING_JOURNEY_CARDS_ENDPOINT = 'https://railsinfo-services.makemytrip.com/api/rails/train/journeycards';

export const VIEW_STATE = {
  LOADING: 'loading',
  SHOW_DETAIL: 'detail',
  DEFAULT: 'default',
  ERROR: 'error',
  NO_RESULT: 'no_result'
};

export const ERROR_LABELS = {
  something_went_wrong: 'Something went wrong!',
  no_trains_found: 'No Trains Found',
  report_missing_train: 'Report Missing Train',
  missing_train_alert: 'missing_train_alert',
  train_not_found_email_body: 'train_not_found_email_body',
  station_picker_page_error: 'Something went wrong. Please try again later',
  try_again: 'Try Again'
};

export const RECENT_SEARCH_CARDS_LIMIT = 5;

export const IMAGE_ALT_TEXT = {
  boardingStationPicker: 'two hollow circles joined with a line',
  calendar: 'blue colored calendar image',
  backArrow: 'back arrow in black color',
  circleWithStarInCenter: 'circle with a star at its center',
  timer: 'circle depicting a clock face with hour and minute hand',
  darkClockFace: 'black coloured clock face with white hour and minute hand',
  blueChevronRight: 'blue coloured chevron pointing to right'
};

export const PRIORITY_OF_DEFAULT_DATE_INDEX_ARRAY = [0, 1, 6, 5, 2, 3, 4];

export const DAYS_OF_RUN_TOMORROW_INDEX = 5;

export const DAYS_OF_RUN_DAY_AFTER_TOMORROW_INDEX = 6;

export const TOAST_MESSAGE = {
  trainNotSelected: 'Please select a train',
  boardingStationNotSelected: 'Please select the Boarding Station',
  trainNotRunningOnDate: 'Train is not running on selected date'
};

export const INSTRUMENTATION_KEYS = {
  tomorrowButtonClick: 'rails_ris_lts_landing_tomorrow_clicked',
  dayAfterTomorrowButtonClick: 'rails_ris_lts_landing_dayafter_clicked',
  upcomingJourneyCardClick: 'rails_ris_lts_landing_upcomingjourneycard_clicked',
  recentSearchesCardClick: 'rails_ris_lts_landing_recentsearches_clicked',
  checkStatusButtonClick: 'rails_ris_lts_landing_checkstatus_clicked',
  trainSelectClick: 'ris_lts_trnno_clicked'
};
